module.exports = __webpack_public_path__ + "img/ost.ea7d89fc.svg";